import { z } from 'zod'

export const ClientCategorySchema = z.enum(['A', 'B', 'C'])

export const ClientSchema = z.object({
  id: z.string().uuid(),
  code: z.string().max(64).nullable(),
  name: z.string().min(1).max(255),
  category: ClientCategorySchema,
  managerId: z.string().uuid(),
  inn: z.string().max(20).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  segment: z.string().max(50).nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type Client = z.infer<typeof ClientSchema>

export const CreateClientSchema = z.object({
  code: z.string().max(64).nullable().optional(),
  name: z.string().min(1).max(255),
  category: ClientCategorySchema,
  managerId: z.string().uuid().optional(),
  notes: z.string().max(5000).nullable().optional(),
  inn: z.string().max(20).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  segment: z.string().max(50).nullable().optional(),
})
export type CreateClientDto = z.infer<typeof CreateClientSchema>

// managerId (владелец клиента) меняется ТОЛЬКО через выделенный гейт
// PATCH /clients/:id/owner (ADMIN/ROP) — с валидацией нового владельца, аудитом
// OWNER_CHANGE, переносом заявок и уведомлениями. На обычном PATCH /clients/:id
// поле принимать нельзя: иначе MANAGER/ROP/Помощник уведут клиента в обход
// проверок (дыра аудита 12.06, HIGH-4 mass-assignment managerId). omit на Update
// НЕ затрагивает CreateClientSchema — createClient по-прежнему принимает managerId.
export const UpdateClientSchema = CreateClientSchema.omit({ managerId: true }).partial()
export type UpdateClientDto = z.infer<typeof UpdateClientSchema>
